<ag-grid-angular
  appGlossScrollGrid
  [class]="'ag-theme-quartz ' + (customGridClass || '')"
  [ngClass]="{
    'remove-top-border': hasTopBorder,
    'gray-selected-ag-grid': selectedRowUsingGray,
  }"
  style="width: 100%"
  [gridOptions]="gridOptions"
  [rowData]="data"
  [domLayout]="'autoHeight'"
></ag-grid-angular>

<!--anthea commit 15 april-->
<!--<ag-grid-angular-->
<!--  class="ag-theme-quartz"-->
<!--  [ngClass]="[-->
<!--    customGridClass,-->
<!--    hasTopBorder ? 'remove-top-border' : '',-->
<!--    selectedRowUsingGray ? 'gray-selected-ag-grid' : '',-->
<!--    gridBgClass,-->
<!--    hideGridBorders-->
<!--      ? '[&#45;&#45;ag-borders:none] [&#45;&#45;ag-row-border-style:none] [&#45;&#45;ag-cell-horizontal-border:none]'-->
<!--      : '',-->
<!--  ]"-->
<!--  style="width: 100%"-->
<!--  [gridOptions]="gridOptions"-->
<!--  [rowData]="data"-->
<!--  [domLayout]="'autoHeight'"-->
<!--&gt;</ag-grid-angular>-->
